module.exports = __webpack_public_path__ + "static/img/admissionCancel.12cd153a.png";